export default {
  'home.email_placeholder': '이메일 주소',
  'home.password_placeholder': '비밀번호',
  'home.remember_me': '로그인 상태 유지',
  'home.logging_in': '로그인 중...',
  'home.login_button': '로그인',
  'home.find_id': '아이디 찾기',
  'home.find_password': '비밀번호 찾기',
  'home.signup_with_email': '이메일로 가입하기',
  'home.sns_login_divider': 'SNS 계정으로 로그인/가입',
  'home.social_login_failed': '소셜 로그인에 실패했습니다.',
  'home.login_failed': '로그인에 실패했습니다.',
  'home.get_started': '시작하기',
  'home.connection_complete': '연결 완료!',
  'home.redirecting_dashboard': '대시보드로 이동합니다...',
  'home.go_back': '← 뒤로가기',
  'home.qr_link_copied': '링크가 복사됐어요',
  'home.qr_link_copy_failed': '복사에 실패했어요. 직접 선택해서 복사해주세요.',
};
